<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute,useRouter } from 'vue-router';
import { productOfferService } from "@/services/productOfferService";
import ProductOffersTable from "./components/ProductOffersTable.vue";
//import ProductCard from "./components/ProductCard.vue";
import OfferEditor from "./OfferEditor/OfferEditor.vue";

import {OfferDiffService} from "./OfferCompare/OfferDiffService.js";
import {OfferDiffFormatter} from "./OfferCompare/OfferDiffFormatter.js";
import { buildSchema } from './OfferEditor/AllegroOfferSchemaBuilder.js';
import OfferCompareModal from "./OfferCompare/OfferCompareModal.vue";

import ArgonButton from "@/components/ArgonButton.vue";


import { ToastService } from '@/services/toastService'

const route = useRoute();
const router = useRouter();

const productOffersCount = ref(0);
const productId = ref(0);
const productOffers = ref();
const product = ref();
const selectedProductOffer = ref(null);

const originalOffer = ref();
const offer = ref(null);

const updateWithAi = ref(false);
const publishToAllegro = ref(false); 

const publication= ref('')
const hasPublishedToAllegro= ref('')
const searchText = ref('');

const sortBy = ref('UpdatedDate');
const sortDesc = ref(true);
const page = ref(1);
const pageSize = ref(25);
const totalCount = ref(0);
const totalPages = ref(1);

async function onSortChanged({ field, desc }) {
    sortBy.value = field;
    sortDesc.value = desc;
}


import { useStore } from "vuex";
const store = useStore();
const selectedShop = computed(() =>
    store.getters.selectedShop
);

const filters = computed(() => {

    const searchRequest = {
        filters: [],
        sorts: [
            {
                field: sortBy.value,
                descending: sortDesc.value
            }
        ],
        page: page.value,
        pageSize: pageSize.value
    };

    console.log('!!!!!!!!!!!!!selectedShop.value',selectedShop.value);
    if (selectedShop.value?.Id) {
        searchRequest.filters.push({
            field: 'ShopId',
            operator: 'eq',
            value: selectedShop.value.Id.toString()
        });
    }

    if (productId.value > 0) {
        searchRequest.filters.push({
            field: 'ProductId',
            operator: 'eq',
            value: productId.value.toString()
        });
    }

    if (searchText.value.trim() !== '') {
        searchRequest.filters.push({
            field: 'OfferName',
            operator: 'icontains',
            value: searchText.value
        });
    }

    if (publication.value !== '') {
        searchRequest.filters.push({
            field: 'Published',
            operator: 'eq',
            value: publication.value.toString()
        });
    }
    console.log("------>>>>>>",hasPublishedToAllegro.value);
    if (hasPublishedToAllegro.value !== '') {
        searchRequest.filters.push({
            field: 'OfferId',
            operator: hasPublishedToAllegro.value,
            value: '0'      
        });
    }

    // if (categoryId.value > 0) {
    //     sarchRequest.filters.push({
    //         field: 'CategoryId',
    //         operator: 'eq',
    //         value: categoryId.value
    //     });
    // }

    console.log('filters xxxx',searchRequest);
    return searchRequest;
});

const searchCriteria = computed(() => ({
    searchText: searchText.value,
    productId:productId.value,
    publication:publication.value,
    page: page.value,
    pageSize: pageSize.value,
    sortBy: sortBy.value,
    sortDesc: sortDesc.value
}));

const initialized = ref(false);

onMounted(async () => {
    productId.value = Number(route.query.productId ?? 0) ;
    //await loadData();
    initialized.value = true;
})

watch(searchCriteria,async (newValues,oldValues) => {

      console.log('watch searchCriteria','initialized.value',initialized.value,'old',oldValues,'->','new',newValues)
      
        if (!initialized.value)
            return;

        if (searchText.value.length > 0 && searchText.value.length < 3) {
            return;
        }
        
        const resetPage = [  'searchText','sortBy','sortDesc','pageSize'].some(key => newValues[key] !== oldValues[key]);

        if (resetPage) {
            page.value = 1;
        }

        router.replace({
            query: {
                productId: productId.value,
                searchText: searchText.value,
                publication: publication.value,
                page: page.value,
                pageSize: pageSize.value,
                sortBy: sortBy.value,
                sortDesc: sortDesc.value
            }
        });

        await loadData();
    },
    {
        deep: true
    }
);

watch(() => route.query, async (newQuery,oldQuery) => {
    
    console.log('watch url','initialized.value',initialized.value, oldQuery,'->',newQuery)
        
    productId.value = Number(newQuery.productId ?? 0);
    searchText.value = newQuery.searchText ?? '';
    publication.value =newQuery.publication ?? '';
    page.value = Number(newQuery.page ?? 1);
    pageSize.value = Number(newQuery.pageSize ?? 25);
    sortBy.value = newQuery.sortBy ?? 'UpdatedDate';
    sortDesc.value = newQuery.sortDesc != null ? newQuery.sortDesc === 'true' : true;


    if (!initialized.value)      
        await loadData();

  },
  { immediate: true }
);

const hasChanges = computed(() => {

    return JSON.stringify(offer.value)
        !==
        JSON.stringify(originalOffer.value);

});

const hasChanges2 = computed(() => {

    return false;

});

async function loadData(){
  await loadProductOffers();
    if(productId.value>0){
      await loadProductById(productId.value);
    }
}

async function loadProductOffers() {
  try{
        const response = await productOfferService.getProductOffersBySearchRequest(filters.value);
    
        if (response.data?.Success) {
        console.log('loadProductOffers response',response.data.Data);

        productOffers.value = await response.data.Data.Items.map(product => {
            let offer = null;

            try {
                offer = JSON.parse(product.OfferJson);
            } catch(error) {
                console.log(error)
            }

            var xResult =  {
                ...product,
                //Offer: offer,
                IsPublished: offer?.publication?.status === 'ACTIVE',
                PublicationStatus : offer?.publication?.status,
                ImageUrl: offer?.productSet[0]?.product?.images?.[0] ?? null
            };

            //console.log(xResult);

            return xResult;
        });

      totalCount.value = response.data.Data.TotalCount;
      totalPages.value = response.data.Data.TotalPages;
      
      productOffersCount.value = productOffers.value?.length;
      updateWithAi.value =productOffersCount.value>0?false:true;
      publishToAllegro.value=productOffersCount.value>0?true:false;

      if (productOffers.value?.length > 0) {
        selectedProductOffer.value = productOffers.value[0];
        originalOffer.value = JSON.parse(productOffers.value[0].OfferJson);
        offer.value = structuredClone(originalOffer.value);
      }
    }
  }catch(error)
  {
    console.error(error);
  }
}

async function loadProductById(productId) {
  try{
    const response =  await productOfferService.GetProductsByProductId(productId)
    if (response.data?.Success) {
      console.log('loadProductById',response.data.Data);
      product.value = response.data.Data;
    }
  }catch(error)
  {
    console.error(error);
  }
}

watch(productId, async (newValue) => {
  console.log('watch:',productId.value,newValue);
  
  router.replace({
      query: {
          ...route.query,
          productId: newValue,
          //page: currentPage.value,
          //search: searchText.value
      }
  });

  
});


async function saveOffer() {

  try {

    const offerJson = JSON.stringify(offer.value,null,2);

    console.log('saveOffer-json',offerJson);
    
    const response = await productOfferService.UpdateProductOffersDescriptionJson({
        productId: productId.value,
        offerJson: offerJson
      });

    if (response.data?.Success) {
      console.log('saveOffer',response.data.Data);
       await loadData();
    }

  }
  catch(error) {

    console.error(error);

    alert("Błąd zapisu");
  }

}

async function selectOffer(productOffer) {
    console.log('selectOffer', productOffer);

    if (productId.value <= 0) {
        await router.push({
                path: '/productoffers',
                query: {
                    productId: productOffer.ProductId
                }
            });

            router.go(0);
            return;
    }

    selectedProductOffer.value = productOffer;

    originalOffer.value = JSON.parse(productOffer.OfferJson);
    offer.value = structuredClone(originalOffer.value);

}

async function AddUpdateProductOffers(){
  console.log('AddUpdateProductOffers','product.value',product.value);
  console.log('AddUpdateProductOffers','productOffers.value',productOffers.value)
  try{
    console.log('AddNewProductOffers: ',productId.value)
     const response = await productOfferService.addUpdateProductOffers(
      { 
        productId:productId.value,
        updateWithAi:updateWithAi.value,
        publishToAllegro:publishToAllegro.value
     });

     if (response.data?.Success) {
       console.log('AddUpdateProductOffers',response.data.Data);
       productOffers.value = response.data.Data;
       productOffersCount.value = productOffers.value?.length;
        
       await loadData();
    }
     
    
  }catch(error)
  {


    ToastService.error("Błąd aktualizacji ofert: "+ error.response?.data?.message +" ("+ error.response?.data?.error    +")");
    console.error(error);
  }
}

async function rollbackChanges(){
   offer.value = structuredClone(originalOffer.value)
}

const showCompare = ref(false);
const compareChangesDATA = ref();

async function compareChanges1(){
  const changes = OfferDiffService.compare(originalOffer.value,offer.value);

  const formatted = OfferDiffFormatter.format(changes,buildSchema(offer.value));

  console.log('compareChanges-1',formatted);
}

async function compareChangesClick() {
    compareChanges1()

      const changes = OfferDiffService.compare(
          originalOffer.value,
          offer.value
      );

      compareChangesDATA.value =
          OfferDiffFormatter.format(
              changes,
              buildSchema(offer.value)
          );

    console.log('compareChanges-2',compareChangesDATA.value);

    showCompare.value = true;

}

</script>
<template>
    <offer-compare-modal
        v-model="showCompare"
        :changes="compareChangesDATA"
    />

     <div class="card m-4" v-if="!productId">

      <!-- Header -->
      <div class="card-header pb-0">
          <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                  Wyszukiwanie 
              </h6>
          </div>
      </div>

      <!-- Body -->
      <div class="card-body">

          <div class="row g-3 align-items-end">

              

              <!-- Nazwa -->
              <div class="col-lg-8">

                  <label class="form-label">
                      Nazwa oferty 
                  </label>

                  <input
                      v-model="searchText"
                      class="form-control"
                      placeholder="Wpisz nazwę oferty..."
                  />

              </div>

               <!-- hasPublishedToAllegro -->
              <div class="col-lg-1">

                  <label class="form-label">
                      Obublikowane w allegro 
                  </label>

                 <select
                      v-model="hasPublishedToAllegro" class="form-select"
                  >
                      <option value="">
                          -- Wszystkie --
                      </option>

                      <option value="isnotnull">
                          TAK
                      </option>

                      <option value="isnull">
                          NIE
                      </option>

                  </select>

              </div>                  

              <!-- Publikacja -->
              <div class="col-lg-1">

                  <label class="form-label">
                      Publikacja
                  </label>

                  <select
                      v-model="publication"
                      class="form-select"
                  >
                      <option value="">
                          -- Wszystkie --
                      </option>

                      <option :value="true">
                          ACTIVE
                      </option>

                      <option :value="false">
                          INACTIVE
                      </option>

                  </select>

              </div>

              <!-- Button -->
              <div class="col-lg-2 d-grid">

                  <argon-button
                      color="dark"
                      variant="gradient"
                      @click="loadData()"
                  >
                      <i class="fas fa-search me-2"></i>
                      Szukaj
                  </argon-button>

              </div>

          </div>

      </div>

      <!-- Footer -->
      <div class="card-footer">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">

              <div>

                  <button
                      class="btn btn-outline-secondary btn-sm me-2"
                      :disabled="page <= 1"
                      @click="page--"
                  >
                      <i class="fas fa-chevron-left"></i>
                      Poprzednia
                  </button>

                  <button
                      class="btn btn-outline-secondary btn-sm"
                      :disabled="page >= totalPages"
                      @click="page++"
                  >
                      Następna
                      <i class="fas fa-chevron-right"></i>
                  </button>

              </div>

              <div class="fw-bold">

                  Strona {{ page }}
                  z {{ totalPages }}

                  <span class="text-muted ms-2">
                      ({{ totalCount }} produktów)
                  </span>

              </div>

              <div class="d-flex align-items-center">

                  <span class="me-2">
                      Na stronę:
                  </span>

                  <select
                      v-model="pageSize"
                      class="form-select"
                      style="width:100px"
                  >
                      <option :value="10">10</option>
                      <option :value="25">25</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                  </select>

              </div>

          </div>

      </div>

    </div>

    <!-- ======================= -->
    <!-- HEADER -->
    <!-- ======================= -->

    <div
        class="container-fluid py-4"
        v-if="productId"
    >

        <div class="card shadow-sm mb-4">

            <div class="card-header">

                <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    <div>

                        <h4 class="mb-1">

                            <i class="fas fa-store me-2 text-primary"></i>

                            Oferta Allegro

                        </h4>

                        <small class="text-muted">

                            Zarządzanie ofertami produktu

                        </small>

                    </div>

                    <div>

                        <span
                            v-if="hasChanges"
                            class="badge bg-warning text-dark fs-6 px-3 py-2"
                        >
                            <i class="fas fa-pen me-1"></i>

                            Niezapisane zmiany

                        </span>

                        <span
                            v-else
                            class="badge bg-success fs-6 px-3 py-2"
                        >
                            <i class="fas fa-check me-1"></i>

                            Wszystkie zmiany zapisane

                        </span>

                    </div>

                </div>

            </div>

            <!-- TOOLBAR -->

            <div class="card-body border-top">

                <div class="d-flex justify-content-between align-items-center flex-wrap gap-4">

                    <!-- Opcje -->

                    <div class="d-flex align-items-center gap-4">

                        <div class="form-check form-switch mb-0">

                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="updateWithAi"
                                v-model="updateWithAi"
                            >

                            <label
                                class="form-check-label ms-2"
                                for="updateWithAi"
                            >

                                🤖 Generuj opis AI

                            </label>

                        </div>

                        <div class="form-check form-switch mb-0">

                            <input
                                class="form-check-input"
                                type="checkbox"
                                id="publishToAllegro"
                                v-model="publishToAllegro"
                            >

                            <label
                                class="form-check-label ms-2"
                                for="publishToAllegro"
                            >

                                🛒 Publikuj do Allegro

                            </label>

                        </div>

                    </div>

                    <!-- Przyciski -->

                    <div class="btn-group">

                        <button
                            class="btn btn-success"
                            @click="saveOffer"
                            :disabled="!hasChanges"
                            v-if="offer"
                        >

                            <i class="fas fa-save me-2"></i>

                            Zapisz

                        </button>

                        <button
                            class="btn btn-outline-secondary"
                            @click="rollbackChanges"
                            v-if="offer && hasChanges"
                        >

                            <i class="fas fa-rotate-left me-2"></i>

                            Cofnij

                        </button>

                        <button
                            class="btn btn-outline-warning"
                            @click="compareChangesClick"
                            v-if="offer && hasChanges"
                        >

                            <i class="fas fa-code-compare me-2"></i>

                            Porównaj

                        </button>

                        <button
                            class="btn btn-dark"
                            @click="AddUpdateProductOffers"
                            :disabled="hasChanges2"
                        >

                            <i class="fas fa-sync-alt me-2"></i>

                            Aktualizuj oferty

                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ======================= -->
    <!-- TABELA OFERT -->
    <!-- ======================= -->

    <div
        class="container-fluid"
    >

        <div class="card shadow-sm mb-4">

            <div class="card-header d-flex justify-content-between align-items-center">

                <h5 class="mb-0">
                    <i class="fas fa-list me-2"></i>
                    Oferty produktu
                </h5>

                <a class="btn btn-link text-info px-3 mb-0"
                href="https://salescenter.allegro.com/my-assortment?limit=1000&sellingMode.format=BUY_NOW&context.marketplace=allegro-pl"
                target="_blank">
                    <i class="fas fa-eye me-2"></i>
                    Allegro asortyment
                </a>

            </div>

            <div class="card-body p-0">

                <product-offers-table

                    v-model="productOffers"

                    @select="selectOffer"

                    :selected-product-offer="selectedProductOffer"

                    @sort-changed="onSortChanged" 
                    
                    :sort-by="sortBy" 
                    
                    :sort-desc="sortDesc" 

                />

            </div>

        </div>

    </div>

    <!-- ======================= -->
    <!-- EDYTOR -->
    <!-- ======================= -->

    <div
        class="container-fluid pb-4"
        v-if="offer && productId"
    >

        <div class="card shadow-sm">

            <div class="card-header">

                <div class="d-flex justify-content-between align-items-center">

                    <h5 class="mb-0">

                        <i class="fas fa-file-code me-2"></i>

                        Edytor oferty

                    </h5>

                    <small class="text-muted">

                        JSON + Opis Allegro

                    </small>

                </div>

            </div>

            <div class="card-body p-0">

                <offer-editor

                    v-model="offer"

                />

            </div>

        </div>

    </div>

</template>
